import { API } from "../../../src/config";

/**
 * @UserQueries
 */

export const userLoginUrl = `${API}/users/login`;
export const requestAccessUrl = `${API}/users/request-access/inarix-portal`;
